import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Blur, Wrapper } from './../Styles';
import { CollapsedView } from './CollapsedView';
import { ExpandedView } from './ExpandedView';
import { NoDataMessage } from './NoDataMessage';

export const RowView = observer(({ largerMonitor, view }) => {
  const {
    DebuggerStore: { logCount },
  } = useStores();

  return logCount === 0 ? (
    <NoDataMessage />
  ) : (
    <Wrapper>
      <Blur position="top" />
      {view === 'collapsed' ? (
        <CollapsedView />
      ) : (
        <ExpandedView largerMonitor={largerMonitor} />
      )}
      <Blur position="bottom" />
    </Wrapper>
  );
});

export default RowView;
